import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppKonvaModule } from '@unpispas/upp-konva';
import { FeatureQrCodeModule } from '@unpispas/feature/qrcode';

import { UppFloorEditComponent } from '../components/edit/upp-edit';
import { UppPlaceEditFloorPanelComponent } from '../components/panel/upp-panel';
import { UppFloorRenderComponent } from '../components/konva/upp-render';
import { UppFloorViewComponent } from '../components/view/upp-view';
import { UppShapeGeometryComponent } from '../components/edit/shapes/common/geometry/upp-geometry';

import {
    UppFloorShapeAddHostComponent,
    UppShapeBarComponent,
    UppShapeBarPickComponent,
    UppShapeBilliardComponent,
    UppShapeBilliardPickComponent,
    UppShapeDoorComponent,
    UppShapeDoorPickComponent,
    UppShapeFootballComponent,
    UppShapeFootballPickComponent,
    UppShapeGenericComponent,
    UppShapeGenericPickComponent,
    UppShapeSofaComponent,
    UppShapeSofaPickComponent,
    UppShapeStairsComponent,
    UppShapeStairsPickComponent,
    UppShapeTableComponent,
    UppShapeWindowComponent,
    UppShapeWindowPickComponent,
    UppVertexComponent,
    UppFloorShapeGroupComponent,
} from '../components/edit/shapes/upp-host';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        UppWdgtModule,
        UppKonvaModule,
        FeatureQrCodeModule,
    ],
    declarations: [
        UppFloorEditComponent,
        UppFloorShapeAddHostComponent,
        UppShapeGeometryComponent,
        UppShapeBarComponent,
        UppShapeBarPickComponent,
        UppShapeBilliardComponent,
        UppShapeBilliardPickComponent,
        UppShapeDoorComponent,
        UppShapeDoorPickComponent,
        UppShapeFootballComponent,
        UppShapeFootballPickComponent,
        UppShapeGenericComponent,
        UppShapeGenericPickComponent,
        UppShapeSofaComponent,
        UppShapeSofaPickComponent,
        UppShapeStairsComponent,
        UppShapeStairsPickComponent,
        UppShapeTableComponent,
        UppShapeWindowComponent,
        UppShapeWindowPickComponent,
        UppVertexComponent,
        UppFloorShapeGroupComponent,
        UppPlaceEditFloorPanelComponent,
        UppFloorRenderComponent,
        UppFloorViewComponent,
    ],
    exports: [UppFloorEditComponent, UppPlaceEditFloorPanelComponent, UppFloorRenderComponent, UppFloorViewComponent],
})
export class FeatureFloorModule {}
